/* @flow */

const invoiceRoutes: Array<*> = [];

export default invoiceRoutes;
